import { connect } from "react-redux";
import { compose } from "redux";

import { getPage } from "./actions";
import Component from "./educationDetailPage";

const mapDispatchToProps = (dispatch) => ({
  onGetPage: (data) => dispatch(getPage(data)),
});

const EducationDetailPage = compose(connect(null, mapDispatchToProps))(
  Component
);

export default EducationDetailPage;
